import { Model } from "./model";
import { Box } from "./box";

export class BoxCertificate extends Model {

  creationDate?: Date;

  endDate?: Date;

  revokeDate?: Date;

  status?: string;

  box?: Box;

  cmId?: string;


}
